import React from "react";
import { Form, Input, Button, Checkbox, Tabs, Row, Col } from "antd";
import { Link } from "react-router-dom";
import Captcha from "react-captcha-code";
import { ReactComponent as PasswordHide } from "@/assets/icons/hidepassword.svg";
import { ReactComponent as PasswordShow } from "@/assets/icons/showpassword.svg";
import {
  GALoginClickToSignUp,
  GALoginClickConfirm,
  GALoginClickToSetPassowrd,
} from "@/ga/login";
import rules from "@/config/rules";
import "../index.less";
const { TabPane } = Tabs;

const LoginRender = React.forwardRef(
  (
    {
      loginLoading,
      handleRequestLogin,
      sendCode,
      isShowCode,
      time,
      handleClickCaptcha,
      handerType,
      loginType,
    },
    captchaRef
  ) => {
    const [form] = Form.useForm();

    /**
     * 自定义密码显示和隐藏icon
     * @param {*} visible
     */
    const passWordIconRender = (visible) =>
      visible ? <PasswordShow /> : <PasswordHide />;

    return (
      <div className="login-page text-center">
        <div className="topContent">
          <h1 className="text-white mb-0">欢迎登录</h1>
        </div>
        <div className="section-login">
          <div className="container">
            <div className="loginForm bg-white mx-auto rounded-3">
              <Tabs
                activeKey={loginType}
                onChange={(activeKey) => handerType(activeKey)}
                centered
                className="tabsText h3"
              >
                <TabPane key="accountLogin" tab={"快捷登录"} />
                <TabPane key="pwdLogin" tab={"密码登录"} />
              </Tabs>
              <Form
                name="form"
                form={form}
                onFinish={handleRequestLogin}
                validateTrigger="onBlur"
                autoComplete="off"
                className="text-start mt-4 pt-lg-0 pt-2"
              >
                {loginType === "accountLogin" && (
                  <>
                    <Form.Item
                      className="require_item"
                      name="phone"
                      rules={[
                        { required: true, message: "请输入您的手机号!" },
                        {
                          pattern: new RegExp(rules.phone),
                          message: "手机号格式不正确，请重新输入",
                        },
                      ]}
                    >
                      <Input placeholder="手机号" />
                    </Form.Item>
                    <Row>
                      <Col>
                        <Form.Item
                          className="require_item"
                          name="verify_code"
                          rules={[
                            { required: true, message: "请输入您的验证码!" },
                          ]}
                        >
                          <Input placeholder="验证码" />
                        </Form.Item>
                      </Col>
                      <Col className="h-100">
                        <Button
                          type="primary"
                          ghost
                          className="code rounded-1"
                          onClick={() =>
                            sendCode(form.getFieldsValue("phone").phone)
                          }
                          disabled={isShowCode ? true : false}
                        >
                          {isShowCode ? `${time}秒后重试` : "获取验证码"}
                        </Button>
                      </Col>
                    </Row>
                    <Form.Item
                      name="agreement"
                      valuePropName="checked"
                      rules={[
                        {
                          validator: (_, value) =>
                            value
                              ? Promise.resolve()
                              : Promise.reject(
                                  new Error("请同意用户服务协议!")
                                ),
                        },
                      ]}
                    >
                      <Checkbox>
                        已阅读并同意牛学长
                        <a
                          href="https://www.niuxuezhang.cn/terms-and-conditions.html"
                          className="text-underline"
                          target="_blank"
                        >
                          《用户服务协议》
                        </a>
                        和
                        <a
                          href="https://www.niuxuezhang.cn/privacy.html"
                          className="text-underline"
                          target="_blank"
                        >
                          《隐私政策》
                        </a>
                        ，未注册用户手机验证后自动登录
                      </Checkbox>
                    </Form.Item>
                  </>
                )}
                {loginType === "pwdLogin" && (
                  <>
                    <Form.Item
                      name="username"
                      className="require_item"
                      rules={[
                        { required: true, message: "请输入您的手机号!" },
                        {
                          pattern: new RegExp(rules.phone),
                          message: "手机号格式不正确，请重新输入",
                        },
                      ]}
                    >
                      <Input placeholder="手机号" />
                    </Form.Item>
                    <Form.Item
                      name="password"
                      className="require_item"
                      rules={[
                        { required: true, message: "请输入您的密码!" },
                        {
                          pattern: new RegExp(rules.password),
                          message:
                            "密码格式错误，8~20位字符，必须包含数字与字母，不允许出现中文与空格。",
                        },
                      ]}
                    >
                      <Input.Password
                        placeholder="密码"
                        iconRender={passWordIconRender}
                      />
                    </Form.Item>
                    <Row>
                      <Col>
                        <Form.Item
                          name="verify_code"
                          rules={[
                            { required: true, message: "请输入您的验证码!" },
                          ]}
                        >
                          <Input placeholder="验证码" />
                        </Form.Item>
                      </Col>
                      <Col>
                        {/* <img src="" alt="" id="captcha" className='ms-4' /> */}
                        <Captcha
                          charNum={4}
                          onChange={handleClickCaptcha}
                          ref={captchaRef}
                          className="ms-3 mt-1"
                          bgColor={"#EDEFF7"}
                        />
                      </Col>
                    </Row>
                  </>
                )}
                <Form.Item className="text-center mb-3">
                  <Button
                    className="ant-btn ant-btn-primary ant-btn-lg submitButton fs-5 fw-bold"
                    htmlType="submit"
                    loading={loginLoading}
                    onClick={() => {
                      GALoginClickConfirm();
                    }}
                  >
                    登录
                  </Button>
                </Form.Item>
                {loginType === "pwdLogin" && (
                  <div className="text-center mb-3 pb-3">
                    <Link
                      className="text-primary text-underline"
                      to="/forgot-password"
                      onClick={GALoginClickToSetPassowrd}
                    >
                      忘记密码
                    </Link>
                    <Link
                      className="text-primary ms-4 text-underline"
                      to={`/register`}
                      onClick={GALoginClickToSignUp}
                    >
                      注册
                    </Link>
                  </div>
                )}
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default LoginRender;
